import { useProgress } from "@react-three/drei";
import loaderTitle from "assets/img/loader-title.png";
import loaderTitleEn from "assets/img/loader-title-en.png";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
const radius = 60;
const stroke = 5;
const Loader = () => {
  const { t } = useTranslation();
  const { progress } = useProgress();

  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;
  const strokeDashoffsetStatic = circumference - 1 * circumference;

  return (
    <Fragment>
      <div className="loadingScreen">
        <div className="mb-5 pb-5 d-flex justify-content-center align-items-center flex-column position-static">
          <img
            src={
              i18next.resolvedLanguage === "pl" ? loaderTitle : loaderTitleEn
            }
            alt=""
          />
          <div className="loader-bottom">
            <div className="circle-container">
              <span className="position-absolute ">
                {Math.round(progress)}%
              </span>
              <div className="circle">
                <svg height={radius * 2} width={radius * 2}>
                  <circle
                    stroke="#f8f3ed80"
                    fill="transparent"
                    strokeWidth={stroke}
                    strokeDasharray={circumference + " " + circumference}
                    style={{ strokeDashoffsetStatic }}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                  />
                  <circle
                    stroke="#EFE07B"
                    fill="transparent"
                    strokeWidth={stroke}
                    strokeDasharray={circumference + " " + circumference}
                    style={{ strokeDashoffset }}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                  />
                </svg>
              </div>
            </div>
            <p className="fs-18 mt-4 pt-3">{t("loaderText")}</p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Loader;
